<template><div key="reports" class="unit-reports">
    <report-list :unitId="id" />
    <div class="static-data" v-if="!noStaticData">
      <template v-if="meta !== null">
        <i>Static Data (to appear on reports):</i>
        <table>
        <tr>
          <th>Name</th>
          <th>Value</th>
          <th>X</th>
        </tr>
        <tr v-for="(m,i) in meta"
            :key="'meta-row-'+i">
          <td><input type="text" placeholder="parameter name" :key="'meta-name-'+i" v-model="m[0]" /></td>
          <td><input type="text" placeholder="value" :key="'meta-val-'+i" v-model="m[1]" /></td>
          <td v-if="i < meta.length - 1" @click="meta.splice(i, 1)">X</td><td v-else />
        </tr>
        </table>
        <button v-if="!staticBusy" @click="saveStaticData">Save</button>
        <span v-else>Saving ...</span>
      </template>
      <span v-else-if="staticBusy">Loading ...</span>
      <button v-else @click="loadStaticData">Error loading static data. Retry.</button>
    </div>
  </div>
</template>
<script>
import api from '../api'
import ReportList from './ReportList'
import axios from 'axios'
export default {
  name: 'unit-reports',
  components: { ReportList },
  data() {
    return {
      meta: null,
      staticRef: null,
      noStaticData: false,
    }
  },
  computed: {
    id() { return this.$store.state.selectedUnit },
    staticBusy() {
      return this.staticRef !== null
    },
  },
  mounted() {
    this.loadStaticData()
  },
  watch: {
    id(nv) {
      this.loadStaticData()
    },
    meta() {
      let last = this.meta[this.meta.length - 1]
      if (!last || last[0] !== '' || last[1] !== '')
        this.meta.push(['',''])
    },
  },
  methods: {
    async loadStaticData() {
      try {
        this.noStaticData = false
        if (this.staticBusy)
          this.staticRef.cancel()
        this.staticRef = { uid: this.id }
        this.meta = await api.unitStaticData(this.staticRef) || []
      } catch(e) {
        if (e.type === 'DoesNotExist')
          this.noStaticData = true
        else if (!(e instanceof api.Canceled))
          console.error(e)
      } finally {
        this.staticRef = null
      }
    },
    async saveStaticData() {
      try {
        if (this.staticBusy)
          this.staticRef.cancel()
        this.staticRef = { uid: this.id, data: this.meta.slice(0, this.meta.length - 1) }
        await api.unitStaticData(this.staticRef)
      } catch(e) {
        console.error(e)
      } finally {
        this.staticRef = null
      }
    },
  },
}
</script>
<style lang="scss">
  .unit-reports {
    padding: 10px 20px;
    .static-data > i {
      display: block;
    }
    table {
      border-collapse: collapse;
      width: 100%;
      margin: 5px 0;
    }
    th, td {
      text-align: left;
      border: 1px solid black;
    }
    th, input, td:last-child { padding: 5px 10px; font-size: 12px; }
    input { border: none; width: 100%; box-sizing: border-box; background-color: transparent; }
    td:first-child { width: 150px }
    td {
      background-color: #fff;
    }
    tr.error td { background-color: #fdd; }
  }
</style>
